// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DemoSystemV2_wrapper__2CqQ8"};